import React, { useEffect } from 'react';
import { useTheme } from '../redux/hooks/useTheme';

const ThemeInitializer = ({ children }) => {
  const { themeMode, setTheme } = useTheme();

  useEffect(() => {
    // Initialize theme from localStorage or system preference
    const initializeTheme = () => {
      // Check if theme is already set in Redux
      if (!themeMode) {
        // Check localStorage for saved theme preference
        const savedTheme = localStorage.getItem('themeMode');
        
        if (savedTheme && (savedTheme === 'light' || savedTheme === 'dark')) {
          setTheme(savedTheme);
        } else {
          // Auto-detect system preference
          const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
          setTheme(prefersDark ? 'dark' : 'light');
        }
      }
    };

    initializeTheme();
  }, [themeMode, setTheme]);

  // Listen for system theme changes
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    
    const handleSystemThemeChange = (e) => {
      // Only auto-switch if user hasn't manually set a preference
      const savedTheme = localStorage.getItem('themeMode');
      if (!savedTheme) {
        setTheme(e.matches ? 'dark' : 'light');
      }
    };

    mediaQuery.addEventListener('change', handleSystemThemeChange);
    
    return () => {
      mediaQuery.removeEventListener('change', handleSystemThemeChange);
    };
  }, [setTheme]);

  // Save theme to localStorage when it changes
  useEffect(() => {
    if (themeMode) {
      localStorage.setItem('themeMode', themeMode);
    }
  }, [themeMode]);

  return <>{children}</>;
};

export default ThemeInitializer;






















